import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Questions, Team } from "../utils/types";
import firebase from "firebase";
import { BeatLoader } from "react-spinners";
import { updateTeamScore } from "../utils/firebase.actions";
import { FALSE_ANSWER_TIME_EFFECT, QUESTION_SCORE } from "../utils/constants";

export default function TeamRow({
  question,
  team,
  updateTeams,
}: {
  question: Questions;
  updateTeams: Function;
  team: Team;
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const [isError, setError] = useState(false);
  useEffect(() => {
    const fetchImage = async () => {
      try {
        setError(false);
        const storageRef = firebase.storage().ref();
        const imageRef = storageRef.child(
          `teams/${team.id}/${question.id}/answer.png`
        );
        const metadata = await imageRef.getMetadata();
        if (metadata.size > 0) {
          const url = await imageRef.getDownloadURL();
          setImageUrl(url);
          setError(false);
        }
      } catch (error) {
        console.log("Error fetching image:", error);
        setError(true);
      }
    };

    fetchImage();
  }, []);

  const isAssignToTrue = useMemo(() => {
    return team.answersScores?.find((id) => id === question.id);
  }, [team.answersScores, team.falseAnswers]);

  const isAssignToFalse = useMemo(() => {
    return team.falseAnswers?.find((id) => id === question.id);
  }, [team.answersScores, team.falseAnswers]);

  const setAnswerToTrue = useCallback(
    async (num: number) => {
      if (!isAssignToTrue) {
        await updateTeamScore(team, question.id, +num);
        updateTeams();
      }
    },
    [team, isAssignToTrue]
  );

  const setAnswerToFalse = useCallback(
    async (num: number) => {
      if (!isAssignToFalse) {
        await updateTeamScore(team, question.id, -num);
        updateTeams();
      }
    },
    [team, isAssignToFalse]
  );

  const answerValue = useMemo(() => {
    return isError ? (
      "No Answer"
    ) : imageUrl ? (
      <section className="answer-container">
        <div className="image-container">
          <img src={imageUrl} alt="Answer" />
        </div>
        <div className="actions-container">
          <i
            className={`fa-solid fa-check ${isAssignToTrue ? "disabled" : ""}`}
            onClick={() => {
              setAnswerToTrue(1);
            }}
          ></i>
          <i
            className={`fa-solid fa-xmark ${isAssignToFalse ? "disabled" : ""}`}
            onClick={() => {
              setAnswerToFalse(1);
            }}
          ></i>
        </div>
      </section>
    ) : (
      <BeatLoader color="#E53526" />
    );
  }, [team, imageUrl, isError, isAssignToTrue, isAssignToFalse]);

  return (
    <tr>
      <td>{team.name}</td>
      <td>{answerValue}</td>
      <td
        className={isAssignToTrue ? "success" : isAssignToFalse ? "danger" : ""}
      >
        {isAssignToTrue
          ? QUESTION_SCORE
          : isAssignToFalse
          ? `+${FALSE_ANSWER_TIME_EFFECT}s`
          : 0}
      </td>
    </tr>
  );
}
